"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("./plugins");
const material_1 = require("@angular/material");
const rxjs_1 = require("rxjs");
const drag_drop_1 = require("@angular/cdk/drag-drop");
const propsicle_class_1 = require("@src/app/xs/utilities/propsicle.class");
const ranger_class_1 = require("@src/app/xs/utilities/ranger.class");
const map_service_1 = require("../map.service");
const Cesium = window.Cesium;
class VisualController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            progress: { value: 0, type: 'progress', noshow: true, nolabel: true },
            // depthTest: { value:false, type:'check', name: this.meta.translator+'.DEPTHTEST',  },
            //extruded: { value:0, name:'Extruded height', type:'slider', min:0, max:500000, step:1 },
            showLabels: { value: false, name: this.meta.translator + '.SHOWLABELS', type: 'check' },
            // labels:  { value:false, name:'Use labels', type:'check', plugConfig:'labels-handler' },
            info: { value: 0, name: this.meta.translator + '.INFO', type: 'info' },
            infoLabels: { value: 0, name: this.meta.translator + '.INFOLABELS', type: 'info' },
            // clamping:  { value:false, name: this.meta.translator+'.CLAMPING', type:'check' },
            useHeight: { value: 'none', name: this.meta.translator + '.USEHEIGHT', type: 'select', options: ['none', 'fixed', 'extruded'], translateOptions: true },
            fixedHeight: { value: 0, name: this.meta.translator + '.FIXEDHEIGHT', type: 'slider', min: 0, max: 50000, step: 1, noshow: true },
            extrudedHeight: { value: false, name: this.meta.translator + '.EXTRUDEDHEIGHT', type: 'select', options: ['none'], noshow: true },
            extrudedHeightFactor: { value: 1, name: this.meta.translator + '.PROPERTYFACTOR', type: 'slider', min: 1, max: 100, step: 1, noshow: true },
        };
        this.show = true;
        // how fast are we going? (label change rate)
        this.pulseSeconds = 1.5;
        // quick checks for visual state
        this.bigPulseSeconds = 0.5;
        // all original entities we're controlling
        this.originalEntities = null;
        // all possible properties (from all entities)
        this.properties = {};
        this.propertiesValueMap = {};
        this.propertiesByEntity = {};
        this.trackedValues = null;
        this.types = {
            polygon: 0,
            polyline: 0,
            billboard: 0,
            ellipse: 0,
            label: 0
        };
        // all our configuration needs to fit in here
        // rules:any = [];
        this.labelEntities = null;
        this.entityProps = null;
        this.usingLiveProperties = 0;
        this.itemShowState = true;
        this._itemShowState = true;
        this.extraDebug = false;
        this.debugResults = {};
        this.xx = 0;
    }
    // progress:XsProgress = new XsProgress();
    construct() {
        //console.log('#construct');
        this.addEntityType('Label', {
            show: this.show,
            label: {
                text: 'aaaaa',
                font: '12px sans-serif',
                showBackground: false,
                fillColor: Cesium.Color.WHITE,
                backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                pixelOffset: new Cesium.Cartesian2(0, -30),
                pixelOffsetScaleByDistance: new Cesium.NearFarScalar(0, 1.5, 2.0e6, 1),
                eyeOffset: new Cesium.Cartesian3(0, 0, -100000),
            },
        });
    }
    init() {
        //console.log('#init');
    }
    end() {
        this.stopPulse();
        this.stopBigPulse();
        this.wipe();
    }
    // override itemInjected as we've got a few more complex things to do
    objectInjected() {
        //console.log('#injected');
        // console.log('@@@@VISUAL-CONTROLLER CONSTRUCTOR',this.object,this.item);
        // transfer over the entities from the injected item's Cesium object(s)
        this.originalEntities = this.object.entities.values;
        // these props are controlled
        this.entityProps = new propsicle_class_1.XsPropsicle({ items: this.originalEntities, itemPropertiesToken: '_properties', itemPropertiesSubToken: '_value' });
        // console.log("@@@@@originalEntities",this.entityProps);
        // pull out all properties of all entities, and create a master index of all properties we can filter on
        this.findAllProperties();
        // these entities are dirty, which means if the plugin is disabled/destroyed, the controller needs to reset those entities
        this.entitiesDirty = true;
        this.startPulse();
        this.startBigPulse();
    }
    // override save as we also want to save something extra
    // save() {
    // console.log("######SAVE",this.rules);
    // this.saveToItem({ rules: this.rules });
    // }
    loadAfter() {
        //console.log("######LOAD_AFTER",this.itemData);
        //if ( this.itemData ) {
        // this.rules = this.itemData['rules'];
        //}
    }
    checkRules(e, n = 0) {
        let result = { id: e.id, idx: n, rangeTrigger: null };
        this.itemData.forEach(rule => {
            result = this.checkRule(result, rule, e);
        });
        return result;
    }
    refreshEntity(e, n = 0) {
        if (this.itemData) {
            let result = { id: e.id, idx: n, rangeTrigger: null };
            this.itemData.forEach(rule => {
                result = this.checkRule(result, rule, e);
            });
            this.doActions(result, e);
            // this.debugResults['_'+n] = result;
        }
    }
    bigPulse() {
        if (this.labelEntities && this.labelEntities.length && this.services.mapService && this.services.mapService.scene) {
            this.itemShowState = this.services.mapService.scene['layerProps'][map_service_1.MapService.VIEW + this.item.id] ? true : false;
            if (this.itemShowState !== this._itemShowState) {
                this._itemShowState = this.itemShowState;
                this.setLabelsView(this.itemShowState);
            }
        }
    }
    setLabelsView(state = true) {
        this.labelEntities.forEach(e => {
            if (e) {
                e.show = state;
            }
        });
    }
    pulse() {
        this.xx = 0;
        if (this.usingLiveProperties) {
            let index = 0;
            this.originalEntities.forEach(e => {
                // find any live attributes
                this.entityProps.updateLiveProperties(e);
                // calculate and get values
                let values = this.convertValuesToProperties(this.checkRules(e, index));
                this.entityProps.updateAttributes(e, values);
                let dirty = this.entityProps.changeDetectAttributes(e);
                /* if ( index == 0 ) {
                    console.log('@@@ VALUES', values );
                    console.log('@@@ DIRTY', dirty );
                    console.log('@@@ ATTR', this.entityProps.itemData[e['__uuid']].attributes );
                } */
                if (dirty) {
                    this.entityProps.solidifyDirtyAttributes(e, dirty);
                }
                // create new hashes
                this.entityProps.updateItemHash(e);
                // update the entity with various styles, labels and colors and icons and whatsnot
                this.refreshEntity(e, index);
                index++;
            });
        }
        if (Math.random() > 0.8) {
            if (this.labelEntities && this.labelEntities.length && this.services.mapService && this.services.mapService.cameralocation) {
                let h = Math.floor(this.services.mapService.cameralocation.height);
                let c = Math.floor(((h + 1) / 200)) + 1;
                this.labelEntities.forEach(e => {
                    if (e && e.label) {
                        e.label.eyeOffset = new Cesium.Cartesian3(0, 0, -c);
                    }
                });
                // console.log('!!eyeOffset', h, c, -c );
            }
        }
    }
    checkRule(incoming, rule, entity) {
        let result = true;
        if (rule.condition) {
            result = false;
            let prop = '_' + rule.condition.property;
            let value = ('' + rule.condition.value).trim();
            if (entity._properties && entity._properties.hasOwnProperty(prop)) {
                // fetch property value
                let test = ('' + entity._properties[prop]).trim();
                const tester = parseInt(rule.condition.testForNegative);
                if (tester == -1) { // not like
                    if (test !== value) {
                        result = true;
                    }
                }
                else if (tester == 1) { // like
                    if (test == value) {
                        result = true;
                    }
                }
                else if (tester == -2) { // under / less than
                    if (parseFloat(test) < parseFloat(value)) {
                        result = true;
                    }
                }
                else if (tester == 2) { // over / more than
                    if (parseFloat(test) > parseFloat(value)) {
                        result = true;
                    }
                }
                // incoming['rule_'+rule.id+'_test'] = [ rule, prop, value, test, result ];
                // console.log('tst', prop, value, test, result);
                // console.log ( '@check cond', entity.id, incoming, [ rule, prop, value, test, result ] );
            }
        }
        if (result && rule.range) {
            let p = this.getPropertyValue(rule.range.property, entity);
            let r = new ranger_class_1.XsRanger({ ranges: rule.range.ranges });
            incoming.rangeTrigger = r.check(parseInt(p));
        }
        if (result) {
            incoming = this.ammendRule(incoming, rule, entity);
        }
        incoming['rule_' + rule.id] = rule;
        // console.log('no_tst', incoming,rule);
        // console.log ( '@check', entity.id, incoming );
        return incoming;
    }
    convertValuesToProperties(incoming) {
        let props = {};
        if (incoming.color) {
            props['color'] = incoming.color.value;
        }
        if (incoming.outline) {
            props['outline_color'] = incoming.outline.value;
            props['outline_width'] = incoming.outline.size;
        }
        if (incoming.label) {
            props['label_text'] = incoming.label.text;
            props['label_text_color'] = incoming.label.text;
        }
        if (incoming.icon) {
            props['icon'] = incoming.icon.image;
        }
        return props;
    }
    doActions(incoming, entity) {
        // console.log ( '@doing', entity.id, incoming );
        if (incoming.color) {
            this.setEntityProperty('color', entity, incoming.color.value);
        }
        if (incoming.outline) {
            this.setEntityProperty('colorOutline', entity, incoming.outline.value);
            this.setEntityProperty('lineWidth', entity, incoming.outline.size);
        }
        if (incoming.label) {
            if (incoming.label.entityId) {
                // console.log ( '@@', this.mapService, this.mapService.viewer, this.mapService.viewer.entites );
                let le = this.labelEntities.find(l => l.id == incoming.label.entityId);
                if (le) {
                    this.setEntityProperty('text', le, incoming.label.text);
                    this.setEntityProperty('textcolor', le, incoming.label.textcolor);
                    // this.setEntityProperty ( 'show', this.itemShowState );
                }
            }
        }
        if (incoming.icon) {
            this.setEntityProperty('image', entity, incoming.icon.image);
        }
    }
    updateEntity(e, n = 0) {
        if (e._polygon) {
            let value = null;
            if (this.controls.useHeight.value == 'none') {
                this.setEntityProperty('perPositionHeight', e, true);
                this.setEntityProperty('height', e, null);
                this.setEntityProperty('extrudedHeight', e, null);
            }
            else if (this.controls.useHeight.value == 'fixed') {
                this.setEntityProperty('perPositionHeight', e, false);
                this.setEntityProperty('height', e, this.controls.fixedHeight.value);
                value = this.controls.fixedHeight.value;
            }
            else if (this.controls.useHeight.value == 'extruded') {
                this.setEntityProperty('perPositionHeight', e, false);
                if (e._properties && e._properties[this.controls.extrudedHeight.value]) {
                    value = parseFloat(e._properties[this.controls.extrudedHeight.value]) * this.controls.extrudedHeightFactor.value;
                    this.setEntityProperty('extrudedHeight', e, value);
                }
            }
            if (this.extraDebug) {
                console.log('## update POLYGON', value);
            }
        }
        if (e._billboard) {
            if (this.extraDebug) {
                console.log('## update BILLBOARD');
            }
            if (this.controls.useHeight.value == 'none') {
                this.setEntityProperty('eyeOffset', e, 0);
            }
            else if (this.controls.useHeight.value == 'fixed') {
                this.setEntityProperty('eyeOffset', e, this.controls.fixedHeight.value);
            }
            else if (this.controls.useHeight.value == 'extruded') {
            }
        }
        //this.setEntityProperty ( 'clamping', e, this.controls.clamping.value );
        //this.setEntityProperty ( 'clampingRelative', e, this.controls.clampingRelative.value );
        if (this.controls.showLabels.value) {
            let pos = null;
            if (e.position) {
                pos = e.position._value;
            }
            else if (this.boundingSphere) {
                pos = this.boundingSphere;
            }
            let config = {
                show: this.show,
                label: {
                    text: '' + Math.random(),
                    font: '12px sans-serif',
                    showBackground: false,
                    fillColor: Cesium.Color.WHITE,
                    backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    pixelOffset: new Cesium.Cartesian2(0, -30),
                    pixelOffsetScaleByDistance: new Cesium.NearFarScalar(0, 1.5, 2.0e6, 1),
                    eyeOffset: new Cesium.Cartesian3(0, 0, -100000),
                },
            };
            // config.label.text = 'HB ' + Math.random()
            if (pos) {
                config.position = pos;
            }
            // console.log('#update');
            // config.label.text = '';
            //let nn = this.services.mapService.viewer.entities.add ( config );
            // this.setEntityProperty ( 'clamping', nn );
            // if ( this.services.mapService && !this.services.mapService.trackedEntity ) {
            //     this.services.mapService.trackedEntity = nn;
            //     nn.label.fillColor = Cesium.Color.RED;
            // }
            //this.labelEntities.push ( nn );
        }
        this.refreshEntity(e, n);
    }
    findLiveProperties() {
        let n = 0;
        if (this.originalEntities) {
            this.originalEntities.forEach(e => {
                if (e['__live_data']) {
                    Object.keys(e['__live_data']).forEach(key => {
                        this.properties['$' + key] = '$' + key;
                    });
                }
                if (n == 0) {
                    // console.log('**** LIVE *****', e, e['__live_data'], this.properties );
                }
                n++;
            });
        }
    }
    // asynchronously populate our property lists
    findAllProperties() {
        return __awaiter(this, void 0, void 0, function* () {
            this.properties.delete;
            this.properties = {};
            this.propertiesValueMap = {};
            let n = 0;
            if (this.originalEntities) {
                this.originalEntities.forEach(e => {
                    const id = e.id;
                    if (n == 0) {
                        // console.log('***** ORIGINAL ****', e, e['__live_data'] );
                    }
                    n++;
                    if (e['__live_data']) {
                        Object.keys(e['__live_data']).forEach(key => {
                            this.properties['$' + key] = true;
                        });
                    }
                    Object.keys(this.types).forEach(type => {
                        if (e[type]) {
                            this.types[type]++;
                        }
                    });
                    let props = e._properties;
                    if (props) {
                        Object.keys(props).forEach(key => {
                            if (props.hasOwnProperty(key)) {
                                if (props[key].hasOwnProperty('_value')) {
                                    this.properties[key] = key.slice(1);
                                    if (!this.propertiesByEntity[id]) {
                                        this.propertiesByEntity[id] = {};
                                    }
                                    this.propertiesByEntity[id][key] = props[key]._value;
                                    if (!this.propertiesValueMap[key]) {
                                        this.propertiesValueMap[key] = {};
                                    }
                                    if (!this.propertiesValueMap[key][props[key]._value]) {
                                        this.propertiesValueMap[key][props[key]._value] = 1;
                                    }
                                    this.propertiesValueMap[key][props[key]._value]++;
                                }
                            }
                        });
                    }
                });
            }
            this.controls.extrudedHeight.options = Object.keys(this.properties);
            // console.log('##################',this.types,this.properties,this.propertiesValueMap, this.propertiesByEntity, this.entityProps );
            let me = this;
            setTimeout(() => { me.findLiveProperties(); me.entityProps.updateAllLiveProperties(); }, 5000);
        });
    }
    sleep(ms = 10) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    refresh(newvalue = null, section = null) {
        let me = this;
        // check in with mama
        super.refresh(newvalue, section);
        this.wipe();
        this.usingLiveProperties = 0;
        if (this.controls.useHeight.value == 'none') {
            this.controls.fixedHeight.noshow = true;
            this.controls.extrudedHeight.noshow = true;
            this.controls.extrudedHeightFactor.noshow = true;
        }
        else if (this.controls.useHeight.value == 'fixed') {
            this.controls.fixedHeight.noshow = false;
            this.controls.extrudedHeight.noshow = true;
            this.controls.extrudedHeightFactor.noshow = true;
        }
        else if (this.controls.useHeight.value == 'extruded') {
            this.controls.fixedHeight.noshow = true;
            this.controls.extrudedHeight.noshow = false;
            this.controls.extrudedHeightFactor.noshow = false;
        }
        this.labelEntities = [];
        if (this.originalEntities) {
            this.controls.info.value = this.originalEntities.length;
            let n = 0;
            // this.extraDebug = true;
            // let allActions:any = {};
            this.updateInChunks(this.originalEntities).then(done => {
                this.entity('labels', this.labelEntities);
                this.controls.infoLabels.value = this.labelEntities.length;
            });
            /*
            this.startCalculating( this.originalEntities.length );

            this.originalEntities.forEach ( e => {

                me.updateCalculationProcess(n);

                // update the entity with various styles, labels and colors and icons and whatsnot
                me.updateEntity(e,n);

                if ( n < 10 ) {
                    // console.log('## e', n, e);
                } else {
                    this.extraDebug = false;
                }

                n++;

            });

            this.endCalculating();
            */
            // this.services.mapService.trackedEntities = this.labelEntities;
            /* this.trackedValues = new XsValueStore({
                items: this.labelEntities,
                track: '__distanceToCamera'
            }); */
            // console.log('ALL_ACTIONS', this.originalEntities.length );
            // this.updatePlug ('legend-handler', this.controls.legend.value ? this.convertToPluginProperties() : null );
        }
        // this.updatePlug ('labels-handler', this.controls.labels.value ? this.labelEntities : null );
    }
    getPropertyValue(propertyName, entity) {
        let ret = '';
        if (propertyName.indexOf('$') == 0) {
            this.usingLiveProperties++;
            // remove first character
            propertyName = propertyName.substr(1);
            // let data = {};
            // Object.keys(this.properties).forEach ( key => {
            //     data[key] = function ( key ) {}; 
            // });
            // live data property
            if (entity['__live_data'] && entity['__live_data'].hasOwnProperty(propertyName)) {
                ret = entity['__live_data'][propertyName] ? ('' + entity['__live_data'][propertyName]).trim() : '';
            }
        }
        else {
            //if ( propertyName.indexOf('_') == 0 ) {
            //    propertyName = propertyName.substr(1);
            //}
            // entity property
            if (entity.properties && entity.properties['_' + propertyName]) {
                ret = entity.properties['_' + propertyName] ? ('' + entity.properties['_' + propertyName]).trim() : '';
            }
        }
        return ret;
    }
    parseLabel(text, entity = null) {
        if (!text) {
            text = '';
        }
        let data = {};
        Object.keys(this.properties).forEach(key => {
            if (key.indexOf('_') == 0) {
                key = key.substr(1);
            }
            else if (key.indexOf('$') == 0) {
                let v = data[key] = this.getPropertyValue(key, entity);
                key = 'fdm_' + key.substr(1);
                data[key] = v;
                return;
            }
            data[key] = this.getPropertyValue(key, entity);
        });
        this.xx++;
        text = ('' + text).trim().split('{$').join('{fdm_');
        // if ( entity._name == 'Aurukun' ) { console.log('##@@##', text, data, this.parseTemplate ( text, data ), entity, this.entityProps ); }
        text = this.parseTemplate(text, data);
        text = ('' + text).trim().split('\\n').join('\n');
        return text;
    }
    ammendRule(incoming, rule, entity = null) {
        if (rule.color) {
            if (!incoming.color) {
                incoming.color = { value: null, debug: [] };
            }
            if (incoming.rangeTrigger !== null) {
                incoming.color.value = rule.color.rangeValue[incoming.rangeTrigger];
            }
            else {
                incoming.color.value = rule.color.value;
            }
            // incoming.color.debug.push(rule.id);
        }
        if (rule.outline) {
            if (!incoming.outline) {
                incoming.outline = { value: null, size: null, debug: [] };
            }
            incoming.outline.value = rule.outline.value;
            incoming.outline.size = rule.outline.size;
            // incoming.outline.debug.push(rule.id);
        }
        if (rule.label) {
            let le = null;
            if (incoming.label && incoming.label.entityId) {
                le = this.labelEntities.find(l => l.id == incoming.label.entityId);
            }
            else {
                le = this.labelEntities.find(l => l.ref == entity.id);
            }
            if (le) {
                incoming.label = { entityId: le.id, text: '', textcolor: '', debug: [] };
                if (incoming.rangeTrigger !== null) {
                    if (rule.label.rangeProperty[incoming.rangeTrigger]) {
                        incoming.label.text = this.getPropertyValue(rule.label.rangeValue[incoming.rangeTrigger], entity);
                    }
                    else {
                        incoming.label.text = rule.label.rangeValue[incoming.rangeTrigger];
                        incoming.label.text = this.parseLabel(incoming.label.text, entity);
                    }
                    incoming.label.textcolor = rule.label.rangeTextcolor[incoming.rangeTrigger];
                }
                else {
                    if (rule.label.property) {
                        incoming.label.text = this.getPropertyValue(rule.label.value, entity);
                    }
                    else {
                        incoming.label.text = rule.label.value;
                        incoming.label.text = this.parseLabel(incoming.label.text, entity);
                    }
                    incoming.label.textcolor = rule.label.textcolor;
                }
                // incoming.label.debug.push(rule.id);
            }
        }
        if (rule.icon) {
            if (!rule.icon['size']) {
                rule.icon['size'] = 30;
            }
            incoming.icon = { size: rule.icon['size'], image: this.services.entityHelper.getPinSvg(rule.icon.value, 'white', rule.icon.size) };
            // note: passing in color 'white' here, as the Cesium color of the icon is actually controlled by the color property, not
            // this image property (technically; the fill stroke passed in gets merged in Cesium, so 'white' means 'full color')
            // this.setEntityProperty ( 'image', entity, this.entityHelper.getPinSvg ( rule.icon.value, 'white', rule.icon.size ) );
        }
        // if ( entity._name == 'Aurukun' ) { console.log('##@@##', incoming, rule ); }
        return incoming;
    }
    getVisualEntityType(entity) {
        let ret = null;
        if (entity._billboard) {
            return 'billboard';
        }
        else if (entity._polygon) {
            return 'polygon';
        }
        else if (entity._label) {
            return 'label';
        }
        else if (entity._description) {
            return 'description';
        }
        else if (entity._point) {
            return 'point';
        }
        else if (entity._polyline) {
            return 'line';
        }
    }
    configure() {
        this.findLiveProperties();
        this.entityProps.updateAllLiveProperties(this.originalEntities);
        this.open().subscribe(result => {
            if (result['rules']) {
                this.itemData = result.rules;
                this.save(); // ToItem({ rules: result.rules });
                this.refresh();
            }
        });
    }
    open() {
        const tmp = new rxjs_1.Observable(subscriber => {
            this.openObservable().subscribe(result => {
                subscriber.next(result);
                subscriber.complete();
            });
        });
        return tmp;
    }
    openObservable() {
        let dialogRef = this.services.dialog.open(ConfigDialog, {
            width: '80%',
            height: '80%',
            data: { title: 'PLUGINS.ENTITY_VISUALIZER.SETUP', properties: this.properties, entities: this.originalEntities, rules: this.itemData }
        });
        return dialogRef.afterClosed();
    }
    // entity modifiers
    setEntityProperty(what, entity, value = '') {
        if (this.extraDebug) {
            console.log('## set', this.getVisualEntityType(entity));
        }
        // console.log ('@', what, value, this.getVisualEntityType(entity) );
        /*
        let current = this.getEntityProperty(what,entity);
        if ( value == current ) {
            console.log('xxxxxx',what,value,current,entity);
            return;
        }
        */
        // console.log('xxxxxx',what,value,this.getEntityProperty(what,entity),entity);
        if (entity) {
            switch (this.getVisualEntityType(entity)) {
                case 'point':
                    if (what == 'color') {
                        entity.point.color = value ? Cesium.Color.fromCssColorString(value) : null;
                    }
                    else if (what == 'show') {
                        entity.show = value;
                    }
                    else if (what == 'coords') {
                        entity.position = value;
                    }
                    break;
                case 'label':
                    if (what == 'color') {
                        entity.label.color = value ? Cesium.Color.fromCssColorString(value) : null;
                    }
                    else if (what == 'show') {
                        entity.show = value;
                    }
                    else if (what == 'text') {
                        entity.label.text = value;
                    }
                    else if (what == 'textcolor') {
                        entity.label.fillColor = value ? Cesium.Color.fromCssColorString(value) : null;
                    }
                    else if (what == 'clamping') {
                        entity.label.heightReference = this.controls.clamping.value ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.RELATIVE; //  Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                    else if (what == 'coords') {
                        entity.position = value;
                    }
                    break;
                case 'billboard':
                    if (what == 'color') {
                        entity.billboard.color = value ? Cesium.Color.fromCssColorString(value) : null;
                    }
                    else if (what == 'image') {
                        entity.billboard.image = value;
                    }
                    else if (what == 'eyeOffset') {
                        entity.billboard.eyeOffset = new Cesium.Cartesian3(0.0, 0.0, -value);
                    }
                    else if (what == 'show') {
                        entity.show = value;
                    }
                    else if (what == 'clamping') {
                        entity.billboard.heightReference = this.controls.clamping.value ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.NONE; //  Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                    else if (what == 'coords') {
                        entity.position = value;
                    }
                    break;
                case 'line':
                    if (what == 'color') {
                        entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                            color: value,
                            outlineColor: Cesium.Color.LIGHTGREY.withAlpha(0.4),
                            outlineWidth: 0
                        });
                        // Cesium.Color.fromCssColorString ( value );
                        // e.polyline.depthFailMaterial.color = Cesium.Color.fromCssColorString ( value ).withAlpha(0.2);
                        // entity.polyline.material.outlineColor = Cesium.Color.fromCssColorString ( value );
                    }
                    else if (what == 'colorOutline') {
                        entity.polyline.material.outlineColor = Cesium.Color.fromCssColorString(value);
                    }
                    else if (what == 'show') {
                        entity.show = value;
                    }
                    else if (what == 'lineWidth') {
                        entity.polyline.material.outlineWidth = value;
                    }
                    else if (what == 'coords') {
                        entity.polyline.positions = value;
                    }
                    else if (what == 'clamping') {
                        entity.polyline.clampToGround = value;
                        entity.polyline.perPositionHeight = !value;
                    }
                    break;
                case 'polygon':
                    if (what == 'coords') {
                        // console.log ( '%c debug =', Constants._red,  what, id, value );
                        entity.polygon.hierarchy = new Cesium.ConstantProperty(new Cesium.PolygonHierarchy(value));
                        // e.polygon.hierarchy = value;
                    }
                    else if (what == 'show') {
                        entity.show = value;
                    }
                    else if (what == 'color') {
                        entity.polygon.material.color = Cesium.Color.fromCssColorString(value);
                    }
                    else if (what == 'colorOutline') {
                        entity.polygon.outlineColor = Cesium.Color.fromCssColorString(value);
                    }
                    else if (what == 'lineWidth') {
                        entity.polygon.width = value;
                    }
                    else if (what == 'height') {
                        entity.polygon.height = value;
                        if (this.extraDebug) {
                            console.log('## set height', entity.polygon);
                        }
                    }
                    else if (what == 'perPositionHeight') {
                        entity.polygon.perPositionHeight = value;
                    }
                    else if (what == 'clamping') {
                        entity.polygon.heightReference = value ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.NONE;
                    }
                    else if (what == 'clampingRelative') {
                        entity.polygon.heightReference = value ? Cesium.HeightReference.RELATIVE_TO_GROUND : Cesium.HeightReference.NONE;
                    }
                    else if (what == 'extrudedHeight') {
                        entity.polygon.extrudedHeight = value;
                    }
                    else if (what == 'extrudedClamping') {
                        entity.polygon.extrudedHeightReference = value ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.NONE;
                    }
                    break;
            }
        }
    }
    getEntityProperty(what, e) {
        if (e) {
            switch (this.getVisualEntityType(e)) {
                case 'line':
                    if (what == 'color') {
                        return e.polyline.material.color;
                    }
                    if (what == 'colorOutline') {
                        return e.polyline.material.outlineColor;
                    }
                    else if (what == 'lineWidth') {
                        return e.polyline.width;
                    }
                    else if (what == 'coords') {
                        // console.log ( '%c debug .', Constants._red, e.polyline, e.polyline.positions, e.polyline._positions )
                        // console.log ( '%c debug _', Constants._red, e._polyline, e._polyline.positions, e._polyline._positions )
                        return e.polyline.positions;
                    }
                    else if (what == 'clamping') {
                        return e.polyline.clampToGround;
                    }
                    break;
                case 'polygon':
                    if (what == 'coords') {
                        return e.polygon.hierarchy;
                    }
                    else if (what == 'color') {
                        return e.polygon.material.color;
                    }
                    else if (what == 'colorOutline') {
                        return e.polygon.material.outlineColor;
                    }
                    else if (what == 'lineWidth') {
                        return e.polygon.width;
                    }
                    else if (what == 'clamping') {
                        return e.polygon.clampToGround;
                    }
                    break;
            }
        }
        return null;
    }
    updateInChunks(items = [], chunkSize = 40) {
        // this.controls.progress.noshow = false;
        // our progress object
        let progress = {
            chunkIndex: 0,
            promises: Math.ceil(items.length / chunkSize) - 1,
            done: 0,
            factor: 100 / items.length
        };
        // console.log ( '%c PROFILER %c SAMPLE_IN_CHUNKS', this.debugPrimary, Constants._red, progress );
        // determined calculation bar
        this.controls.progress.value = 0;
        this.startCalculating(items.length);
        // let's make a promise ...
        let thisPromise = new Promise(resolve => {
            this.updatePromiseRecursive(items, chunkSize, resolve, progress);
        });
        return thisPromise;
    }
    updatePromiseRecursive(items = [], chunkSize = 50, resolve = null, progress = {}) {
        let itemsProcess = items.slice(progress.chunkIndex, progress.chunkIndex + chunkSize);
        let itemsLeftOver = items.slice(progress.chunkIndex + chunkSize);
        // console.log ( '%c PROFILER %c SAMPLE_RECURSE', this.debugPrimary, Constants._red, positionsProcess.length, positionsLeftOver.length, progress );
        this.updateItems(itemsProcess).then(chunk => {
            progress.done++;
            let p = progress.done * (progress.factor * itemsProcess.length);
            this.controls.progress.value = p;
            this.updateCalculationProcess(progress.done * chunkSize);
            // console.log ( '%c PROFILER %c SAMPLE_RECURSE THEN', this.debugPrimary, Constants._red, this.percentFinished, progress, chunk );
            /*
                for ( let n=0; n<chunk.length; n++ ) {
                    
                    items[progress.chunkIndex+n] = chunk[n];
                    let coord = Cesium.Cartesian3.fromRadians(chunk[n].longitude, chunk[n].latitude, chunk[n].height) ;
                    this.entityHelper.addEntity( AnnotationType.volumepoint, { coord: coord }, 'volumepoint', 'volume_calc' );
                    // console.log ( '%c PROFILER %c PROMISED CHUNK FLICK='+idx, this.debugPrimary, Constants._red, n, chunk[n] );
                }
            */
            if (itemsLeftOver.length && progress.done < progress.promises) {
                setTimeout(() => {
                    // recursive loop the rest
                    progress.chunkIndex = progress.chunkIndex + chunkSize;
                    // console.log ( '%c PROFILER %c SAMPLE_RECURSE RECURSE_MORE', this.debugPrimary, Constants._red, positionsLeftOver.length );
                    this.updatePromiseRecursive(items, chunkSize, resolve, progress);
                }, 30);
            }
            else {
                // done, resolve
                // console.log ( '%c PROFILER %c SAMPLE_RECURSE DONE', this.debugPrimary, Constants._red, progress );
                this.controls.progress.noshow = true;
                this.endCalculating();
                resolve(items);
            }
        });
    }
    updateItems(items = []) {
        return new Promise(resolve => {
            let n = 0;
            items.forEach(item => {
                this.updateEntity(item, n++);
            });
            resolve(items);
        });
    }
}
VisualController.meta = {
    label: 'PLUGINS.ENTITY_VISUALIZER.LABEL',
    name: 'visual-controller',
    translator: 'PLUGINS.ENTITY_VISUALIZER',
    tooltip: 'PLUGINS.ENTITY_VISUALIZER.TOOLTIP',
    shortcut: true,
    icon: 'paint-brush',
    category: plugins_1.FdmPlugin.category.generic,
    types: [
        plugins_1.FdmPlugin.types.transformController,
        plugins_1.FdmPlugin.types.entityController
    ],
    features: [
        plugins_1.FdmPlugin.features.configuration
    ],
    ds_types: [
        plugins_1.FdmPlugin.ds_types.geo_json,
        plugins_1.FdmPlugin.ds_types.kml,
        plugins_1.FdmPlugin.ds_types.wfs
    ],
    cardinality: [
        plugins_1.FdmPlugin.cardinality.one
    ]
};
exports.VisualController = VisualController;
class ConfigDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.loading = false;
        this.rules = [];
        this.controllers = ['condition', 'range', 'label', 'icon', 'color', 'outline'];
        // console.log ( '@@@', data );
        if (this.data.rules) {
            this.rules = this.data.rules;
        }
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    addRule() {
        this.rules.push({ id: this.uuidv4(), condition: false, range: false, color: false, icon: false, label: false });
    }
    removeRule(me) {
        this.rules = this.rules.filter(function (returnableObjects) {
            return returnableObjects.id !== me.id;
        });
    }
    updateRuleValue(item, idx = 0, me) {
        // console.log('*** updateRuleValue()', item, idx, me );
        item[idx] = me.srcElement.value;
    }
    addRange(idx, ranges) {
        // if ( ranges.length == idx ) {
        // ranges.push(ranges[idx]+100);
        // } else {
        let v = (ranges[idx] - ranges[idx + 1] ? ranges[idx + 1] : ranges[idx] - 1) / 2;
        ranges.splice(idx + 1, 0, v);
        // }
    }
    deleteRange(idx, ranges) {
        if (ranges.length == idx) {
            ranges.pop();
        }
        else {
            ranges.splice(idx, 1);
        }
    }
    setController(what, rule) {
        if (rule[what]) {
            rule[what] = false;
        }
        else {
            if (what == 'condition') {
                rule[what] = {
                    property: '',
                    value: '',
                    testForNegative: false
                };
            }
            else if (what == 'range') {
                rule[what] = {
                    property: '',
                    value: '',
                    ranges: [0, 100],
                };
            }
            else if (what == 'color') {
                rule[what] = { value: '#888888', rangeValue: [] };
            }
            else if (what == 'outline') {
                rule[what] = { value: 'yellow', size: 1, rangeValue: [], rangeSize: [] };
            }
            else if (what == 'label') {
                rule[what] = { value: 'Some label', property: false, size: 14, textcolor: 'white', rangeValue: [], rangeProperty: [], rangeSize: [], rangeTextcolor: [] };
            }
            else if (what == 'icon') {
                rule[what] = { value: 'pin', size: 30, rangeValue: [], rangeSize: [] };
            }
        }
    }
    drop(event) {
        drag_drop_1.moveItemInArray(this.rules, event.previousIndex, event.currentIndex);
    }
    onCancelClick() {
        this.dialogRef.close(false);
    }
    onSaveClick() {
        // let el = document.getElementById('texteditor') as HTMLInputElement;
        // if ( el ) {
        //     this.data.text = el.value;
        // }
        this.data.rules = this.rules;
        this.dialogRef.close(this.data);
    }
}
exports.ConfigDialog = ConfigDialog;
class XsProgress {
    constructor() {
        this.percentFinished = 0;
    }
    reset() {
        this.percentFinished = 0;
    }
    update(percent) {
        this.percentFinished = percent;
    }
}
exports.XsProgress = XsProgress;
